module.exports = __webpack_public_path__ + "static/media/13.22046b82.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/13.jpeg
// module id = 583
// module chunks = 0